import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { ACCEPT_ATTRIBUTE, MAX_ATTACHMENTS, formatFileSize } from "./attachmentRules";

/**
 * Gönderilmeden önceki ek listesi: dosya seçme düğmesi ve seçilenlerin önizlemesi.
 * Panodan yapıştırma, mesaj alanına bağlanan useTicketAttachments().handlePaste ile çalışır.
 */
const AttachmentPicker = ({ items, onAdd, onRemove, disabled }) => {
    const inputRef = useRef(null);

    const pick = (event) => {
        onAdd(event.target.files);
        // Aynı dosyanın arka arkaya seçilebilmesi için input sıfırlanır
        event.target.value = "";
    };

    return (
        <div>
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <Button
                    type="button"
                    size="sm"
                    outline
                    className="rounded-pill d-inline-flex align-items-center gap-1"
                    disabled={disabled || items.length >= MAX_ATTACHMENTS}
                    onClick={() => inputRef.current?.click()}
                >
                    <FeatherIcon icon="paperclip" size={14} />
                    Dosya ekle
                </Button>
                <small className="text-muted">
                    png, jpg · en fazla {MAX_ATTACHMENTS} görsel · Ctrl+V ile ekran görüntüsü yapıştırabilirsiniz
                </small>
                <input
                    ref={inputRef}
                    type="file"
                    multiple
                    accept={ACCEPT_ATTRIBUTE}
                    onChange={pick}
                    className="d-none"
                />
            </div>

            {items.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-2">
                    {items.map(item => (
                        <div
                            key={item.id}
                            className="d-flex align-items-center gap-2 border rounded p-2"
                            style={{ maxWidth: "100%" }}
                        >
                            {item.previewUrl ? (
                                <img
                                    src={item.previewUrl}
                                    alt={item.name}
                                    style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 4 }}
                                />
                            ) : (
                                <FeatherIcon icon="image" size={20} className="text-secondary" />
                            )}

                            <div style={{ minWidth: 0 }}>
                                <div
                                    className="text-truncate"
                                    style={{ maxWidth: 180, fontSize: ".8rem" }}
                                    title={item.name}
                                >
                                    {item.name}
                                </div>
                                <div className="text-muted" style={{ fontSize: ".72rem" }}>
                                    {formatFileSize(item.size)}
                                </div>
                            </div>

                            <Button
                                type="button"
                                close
                                aria-label={`${item.name} ekini kaldır`}
                                disabled={disabled}
                                onClick={() => onRemove(item.id)}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

AttachmentPicker.propTypes = {
    items: PropTypes.array.isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default AttachmentPicker;
